import React, {useContext} from "react";
import {
    Button,
    Drawer,
    IconButton,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Stack
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
    IconBulldozer,
    IconLogout,
    IconMenu,
} from "@tabler/icons-react";
import {NavLink} from "react-router-dom";
import {WebSettingsContext} from "../../../context/WebSettingsContext";

export const HeaderDrawer = ({open, handleClose, isAuth, isAdmin, currentUser, onLogout, openModal}) => {

    const {settings, onUnderMaintenance} = useContext(WebSettingsContext);

    const logoutHandle = async () => {
        try {
            await onLogout();
            handleClose();
        } catch (err) {
            console.error(err);
        }
    }

    const handleNav = () => handleClose();

    return (
        <Drawer
            anchor={"right"}
            open={open}
            onClose={handleClose}
            sx={{
                height: "100vh",
                width: '100%',
                flex: 1,
                display: {xs: "inherit", md: "none"}
            }}
            PaperProps={{
                sx: {
                    maxWidth: "360px",
                    width: "100% !important",
                },
            }}
        >
            <Stack direction={"column"} gap={1} sx={{
                height: "100vh",
                maxWidth: "360px",
                width: "100% !important",
                bgcolor: "#FFF"
            }}>
                <Box sx={{ p: 2, bgcolor: "#FFF" }}>
                    <IconButton onClick={handleClose}>
                        <IconMenu />
                    </IconButton>
                </Box>

                {isAuth && currentUser && (
                    <Box sx={{ px: 2, pb: 1 }}>
                        <Typography variant={"subtitle2"} fontWeight={"bold"}>
                            {currentUser?.name} {currentUser?.lastname}
                        </Typography>
                    </Box>
                )}

                <Box sx={{ flex: 1, maxHeight: "100%", overflowY: 'auto' }}>
                    <List>
                        {isAdmin && (
                            <>
                                <ListItemButton onClick={handleNav} component={NavLink} to={"/projects"} end>
                                    <ListItemText>
                                        <Typography variant={"subtitle2"} fontWeight={"bold"}>Projects</Typography>
                                    </ListItemText>
                                </ListItemButton>
                                <ListItemButton onClick={handleNav} component={NavLink} to={"/organizations"}>
                                    <ListItemText>
                                        <Typography variant={"subtitle2"} fontWeight={"bold"}>Organizations</Typography>
                                    </ListItemText>
                                </ListItemButton>
                                <ListItemButton onClick={handleNav} component={NavLink} to={"/ai-models"}>
                                    <ListItemText>
                                        <Typography variant={"subtitle2"} fontWeight={"bold"}>AI models</Typography>
                                    </ListItemText>
                                </ListItemButton>
                            </>
                        )}

                        {isAdmin && (
                            <ListItemButton onClick={onUnderMaintenance}>
                                <ListItemIcon>
                                    <IconBulldozer color={settings?.underMaintenance ? "#d32f2f" : undefined} />
                                </ListItemIcon>
                                <ListItemText primary={"Under Maintenance"} />
                            </ListItemButton>
                        )}

                        {isAuth ? (
                            <ListItemButton onClick={logoutHandle}>
                                <ListItemIcon>
                                    <IconLogout />
                                </ListItemIcon>
                                <ListItemText primary={"Logout"} />
                            </ListItemButton>
                        ) : (
                            <Box sx={{ px: 2, pt: 1 }}>
                                <Button
                                    fullWidth
                                    onClick={() => {
                                        openModal();
                                        handleClose();
                                    }}
                                    sx={{
                                        borderRadius: 0,
                                        textTransform: "capitalize",
                                        fontSize: 14,
                                        fontWeight: "bold",
                                        color: '#4a4a4a',
                                        borderColor: "#4a4a4a",
                                        border: 1,
                                        "&:hover": {
                                            color: "#FFF",
                                            bgcolor: "#4a4a4a"
                                        }
                                    }}
                                >
                                    Sign in
                                </Button>
                            </Box>
                        )}
                    </List>
                </Box>
            </Stack>
        </Drawer>
    )
}
